module.exports = __webpack_public_path__ + "static/media/doorGasket.8d8f4fd2.png";